var React = require('react');


var Layout = React.createClass({
  render: function () {
    return (
      <div className="ofs-FormLayout">
        {this.props.children}
      </div>
    );
  }
});

module.exports = Layout;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/layout/layout.jsx
 **/